import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllContactAutomationsQueries } from './queries/useContactAutomationsQuery';

export function useStartAutomationContactMutation({
	impersonationContext,
	onSuccess,
	onError,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}) {
	const userSession = useUserSession();

	return useMutation({
		mutationKey: ['startAutomationContact'],
		onSuccess: () => {
			invalidateAllContactAutomationsQueries();
			onSuccess?.();
		},
		onError,
		mutationFn: ({
			id,
			createAutomationRequest,
		}: {
			id: string;
			createAutomationRequest: Api.ICreateAutomationRequest;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `Automation/${id}/Contact`,
				}),
				'POST',
				createAutomationRequest
			);
		},
	});
}
